module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "nav-menu-open-checkbox"
    },
    domProps: {
      "checked": _vm.open
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71d0084a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuOpenstatehandler.vue
// module id = 463
// module chunks = 2